import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import newLogo from '../../assets/images/tmov-logo-branco.svg';
import { Container, Imagem } from './styles';

function Logo({ size, linkTo }) {
  return <Container>
    <Link to={linkTo}>
      <Imagem alt="Tmov Gr" src={newLogo} size={size} />
    </Link>
         </Container>;
}

Logo.propTypes = {
  size: PropTypes.string,
  linkTo: PropTypes.string,
};

Logo.defaultProps = {
  size: 'md',
  linkTo: '',
};

export default Logo;
